import React, { useContext } from "react";

import TagContext from "../../context/tag/tagContext";

import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@mui/material/Typography';

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

const TagsNavigator = ({ currentTags }) => {
  const classes = useStyles();

  const tagContext = useContext(TagContext);

  const { tags } = tagContext;

  let tagsToShow = currentTags === null ? null : currentTags.split(",");
  if (tagsToShow !== null) {
    tagsToShow = tagsToShow.filter((tag) => {
      return tag !== "";
    });
  }

  const handleClick = (tag) => {
    let updatedTags = "";
    if (currentTags === null || currentTags === "") {
      updatedTags = `?tags=${tag.name}`;
    } else {
      updatedTags = `?tags=${currentTags},${tag.name}`;
    }
    window.location.href = `/memory${updatedTags}`;
  };

  return (
    <Paper elevation={0}>
      <Typography variant="h5">Categories </Typography>
      <div className={classes.chips}>
        {tags && tags.length !== 0 ? (
          tags.map((tag) => {
            if (tagsToShow !== null && tagsToShow.includes(tag.name)) {
              return (
                <Chip
                  label={tag.name}
                  onClick={() => {}}
                  key={tag.id}
                  color="primary"
                  style={{ backgroundColor: "#03a9f4" }}
                />
              );
            }
            return (
              <Chip
                variant="outlined"
                label={tag.name}
                onClick={() => handleClick(tag)}
                key={tag.id}
              />
            );
          })
        ) : (
          <div />
        )}
      </div>
    </Paper>
  );
};

export default TagsNavigator;
